
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/speakers/[id]",
      function () {
        return require("private-next-pages/speakers/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/speakers/[id]"])
      });
    }
  